import { __read } from "tslib";
import { isBoolean, isInRange, isString, isValidSemanticVersion } from '@dazn/peng-html5-tools-utils';
import { MHID_DELIMITER } from "../Constants/MhidDelimiter";
import { MHID_PREFIX } from "../Constants/MhidPrefix";
/**
 * Checks whether the provided string is a valid message history correlation ID, as generated by
 * `createMhid()`.
 *
 * @param withShardIndex An optional boolean dictating that the provided ID is expected to contain
 * a shard index (e.g `'..._3'`), and should be validated as such.
 */
var isValidMhid = function (mhid, withShardIndex) {
    // If falsey, or not a string, the ID is invalid
    if (!mhid || !isString(mhid))
        return false;
    var parts = mhid.split(MHID_DELIMITER);
    // Check number of parts based on whether the `withShardIndex` is specifically defined
    var invalidPartsLength = (isBoolean(withShardIndex) &&
        ((!withShardIndex && parts.length !== 4) || (withShardIndex && parts.length !== 5))) ||
        !isInRange(4, parts.length, 5);
    if (invalidPartsLength)
        return false;
    var _a = __read(parts, 5), projectNamespace = _a[0], version = _a[1], dateTimeNowAsNumber = _a[2], randomId = _a[3], optionalShardIndex = _a[4];
    // If the ID did not originate from cadmium (CAD), then the ID is invalid
    if (projectNamespace !== MHID_PREFIX)
        return false;
    if (!isValidSemanticVersion(version))
        return false;
    // If the date time does not have exactly 17 digits, then the ID is invalid
    // @example: `202310121233123`
    if (dateTimeNowAsNumber.length !== 17)
        return false;
    // If the random ID is not 6 characters long, then the ID is invalid
    if (randomId.length !== 6)
        return false;
    // If the ID has a shard index, but it is not an integer, the ID is invalid
    if (isString(optionalShardIndex) && !/^\d+$/.test(optionalShardIndex))
        return false;
    return true;
};
export { isValidMhid };
//# sourceMappingURL=isValidMhid.js.map